import React from 'react';
import Image from '../../../components/AppImage';

const ClientLogoCarousel = () => {
  const clients = [
    {
      id: 1,
      name: "TechCorp Solutions",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1685a64c8-1766711036159.png",
      logoAlt: "TechCorp Solutions modern blue and white geometric logo with abstract tech symbol on white background"
    },
    {
      id: 2,
      name: "InnovateLabs",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_12350c212-1764663833536.png",
      logoAlt: "InnovateLabs minimalist black logo featuring stylized lightbulb icon with company name in modern sans-serif font"
    },
    {
      id: 3,
      name: "Digital Dynamics",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_171f76b94-1767113668054.png",
      logoAlt: "Digital Dynamics colorful gradient logo with interconnected circular nodes representing digital connectivity"
    },
    {
      id: 4,
      name: "CloudScale Inc",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_142600464-1766474210656.png",
      logoAlt: "CloudScale Inc professional logo with cloud icon and bold typography in navy blue and silver colors"
    },
    {
      id: 5,
      name: "StartupHub",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_151c44201-1767113671585.png",
      logoAlt: "StartupHub vibrant orange and purple logo with rocket ship symbol and modern geometric letterforms"
    },
    {
      id: 6,
      name: "Enterprise Systems",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_18de84622-1767113669358.png",
      logoAlt: "Enterprise Systems corporate logo featuring abstract building structure in dark gray with red accent line"
    }
  ];

  return (
    <section className="relative py-14 md:py-20 bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0a0f1c] border-y border-border overflow-hidden">
      {/* Futuristic glowing background shapes */}
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[80vw] h-64 bg-gradient-to-r from-cyan-500/20 via-blue-500/10 to-purple-600/20 blur-3xl rounded-full opacity-70"></div>
      <div className="pointer-events-none absolute bottom-0 right-0 w-72 h-72 bg-gradient-to-tr from-purple-500/20 via-blue-400/10 to-cyan-400/20 blur-2xl rounded-full opacity-60"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-base md:text-lg font-bold uppercase tracking-widest text-cyan-400 drop-shadow-lg">
            Trusted by Industry Leaders
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div className="flex animate-scroll-infinite">
            {[...clients, ...clients]?.map((client, index) => (
              <div
                key={`${client?.id}-${index}`}
                className="flex-shrink-0 w-32 md:w-40 lg:w-48 mx-4 md:mx-6 lg:mx-8"
              >
                <div className="aspect-[3/2] flex items-center justify-center p-4 md:p-6 rounded-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 border border-cyan-500/30 shadow-xl hover:shadow-cyan-400/40 hover:scale-105 transition-all duration-300 group relative">
                  {/* Neon glow effect */}
                  <div className="absolute inset-0 rounded-2xl pointer-events-none group-hover:shadow-[0_0_24px_4px_rgba(34,211,238,0.25)] transition-all duration-300"></div>
                  <Image
                    src={client?.logo}
                    alt={client?.logoAlt}
                    className="w-full h-full object-contain drop-shadow-[0_2px_8px_rgba(34,211,238,0.15)]"
                    style={{ filter: 'none' }}
                  />
                </div>
                <div className="mt-3 text-center text-xs md:text-sm font-semibold text-cyan-100 tracking-wide drop-shadow">
                  {client?.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogoCarousel;